import script from "./HrSettings.vue?vue&type=script&lang=ts&setup=true"
export * from "./HrSettings.vue?vue&type=script&lang=ts&setup=true"

import "./HrSettings.vue?vue&type=style&index=0&id=d8eeebd6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d8eeebd6"]])

export default __exports__